/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ModelUserTasks,
  ErrorInfo,
  TaskListMasters,
  TaskSearchResult,
  TaskSearchConditions,
  BinaryFile,
  TaskResultData
} from '.././model'


/**
 * 機種担当のタスク一覧を取得して返す。

 * @summary 機種担当のタスク一覧取得
 */
export const getModelUserTasks = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ModelUserTasks>> => {
    return axios.get(
      `/tasks/modelUserTasks`,options
    );
  }


export const getGetModelUserTasksQueryKey = () => [`/tasks/modelUserTasks`];

    
export type GetModelUserTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getModelUserTasks>>>
export type GetModelUserTasksQueryError = AxiosError<ErrorInfo>

export const useGetModelUserTasks = <TData = Awaited<ReturnType<typeof getModelUserTasks>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getModelUserTasks>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModelUserTasksQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelUserTasks>>> = ({ signal }) => getModelUserTasks({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getModelUserTasks>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * タスク一覧に必要なマスタを一括取得して返す。

 * @summary タスク一覧マスタ一括取得
 */
export const getTasksMasters = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TaskListMasters>> => {
    return axios.get(
      `/tasks/masters`,options
    );
  }


export const getGetTasksMastersQueryKey = () => [`/tasks/masters`];

    
export type GetTasksMastersQueryResult = NonNullable<Awaited<ReturnType<typeof getTasksMasters>>>
export type GetTasksMastersQueryError = AxiosError<ErrorInfo>

export const useGetTasksMasters = <TData = Awaited<ReturnType<typeof getTasksMasters>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTasksMasters>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTasksMastersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasksMasters>>> = ({ signal }) => getTasksMasters({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getTasksMasters>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * ユーザー/グループのタスク一覧を取得して返す。

 * @summary ユーザー/グループのタスク一覧取得
 */
export const postTasksSearch = (
    taskSearchConditions: TaskSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TaskSearchResult>> => {
    return axios.post(
      `/tasks/search`,
      taskSearchConditions,options
    );
  }



    export type PostTasksSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postTasksSearch>>>
    export type PostTasksSearchMutationBody = TaskSearchConditions
    export type PostTasksSearchMutationError = AxiosError<ErrorInfo>

    export const usePostTasksSearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTasksSearch>>, TError,{data: TaskSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTasksSearch>>, {data: TaskSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postTasksSearch(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTasksSearch>>, TError, {data: TaskSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * タスク一覧をダウンロード

 * @summary タスク一覧をダウンロード
 */
export const postTasksDownload = (
    taskResultData: TaskResultData, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/tasks/download`,
      taskResultData,options
    );
  }



    export type PostTasksDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postTasksDownload>>>
    export type PostTasksDownloadMutationBody = TaskResultData
    export type PostTasksDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostTasksDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTasksDownload>>, TError,{data: TaskResultData}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTasksDownload>>, {data: TaskResultData}> = (props) => {
          const {data} = props ?? {};

          return  postTasksDownload(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTasksDownload>>, TError, {data: TaskResultData}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 通知メールチェック用

 * @summary 通知メールチェック用（いずれ削除）
 */
export const getTaskMailCheck = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/tasks/mailCheck`,options
    );
  }


export const getGetTaskMailCheckQueryKey = () => [`/tasks/mailCheck`];

    
export type GetTaskMailCheckQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskMailCheck>>>
export type GetTaskMailCheckQueryError = AxiosError<ErrorInfo>

export const useGetTaskMailCheck = <TData = Awaited<ReturnType<typeof getTaskMailCheck>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTaskMailCheck>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskMailCheckQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskMailCheck>>> = ({ signal }) => getTaskMailCheck({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getTaskMailCheck>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

